import "./styles.scss";

import { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import comentsPNG from "../../../assets/images/ic-coments.png";
import { createCommentForCoordinator } from "../../../store/middleware";
import { clearReportStatus } from "../../../store/slices/methodology.slice";

function ModalCommunicationsCoordinator({ showModal, setShowModal }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { report } = useSelector((state) => state.methodologyReducer);

  const [comments, setComments] = useState("");
  const [showComments, setShowComments] = useState(false);

  // const handleCloseModal = () => setShowModal(false);
  const openShowComments = () => setShowComments(true);

  const handleClose = () => {
    navigate("/report");
    setShowModal(false);
    setShowComments(false);
    dispatch(clearReportStatus());
  };

  const handleSave = (e) => {
    e.preventDefault();

    const payload = {
      userId: user?.id,
      comment: comments,
      teacherId: report[0]?.teacherId,
      studentId: report[0]?.studentId,
      sequentialScheduleId: report[0]?.sequentialScheduleId,
    };
    dispatch(createCommentForCoordinator(payload)).then((resp) => resp && handleClose());
  };

  return (
    <Dialog
      open={showModal}
      onClose={handleClose}
      className="modalPrivilege"
      aria-labelledby="alert-dialog-title"
      classes={"modalCommunicationsCoordinator"}
      aria-describedby="alert-dialog-description"
    >
      <div className="containerCommunicationsCoordinator">
        <h3 className="title">{t("COMMUNICATION COORDINATOR")}</h3>

        <div className="content">
          <img src={comentsPNG} alt="comentsPNG" />
          <p>{t("COMMUNICATE_SOMETHING_COORDINATOR")}</p>

          {showComments && (
            <textarea
              value={comments}
              placeholder={t("ENTER_STATEMENT_HERE")}
              onChange={(e) => setComments(e.target.value)}
            />
          )}
        </div>

        <div className="footer">
          {!showComments ? (
            <button type="submit" onClick={openShowComments} className="buttonModalSave">
              {t("YES_COMMUNICATE")}
            </button>
          ) : (
            <button type="submit" onClick={handleSave} className="buttonModalSave">
              {t("FINISH")}
            </button>
          )}
          <button type="button" onClick={handleClose} className="buttonModalBack">
            {t("NO_FINISH")}
          </button>
          {/* <button type="button" onClick={handleCloseModal} className="buttonModalBack">
            {t("BACK")}
          </button> */}
        </div>
      </div>
    </Dialog>
  );
}

export default ModalCommunicationsCoordinator;
